import { MessageCircle } from "lucide-react";

const WhatsAppButton = () => {
  const phoneNumber = "972545725681";
  const message = encodeURIComponent("שלום, אשמח לקבל פרטים נוספים על שירותי אור בגג");
  const url = `https://wa.me/${phoneNumber}?text=${message}`;

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="שלחו הודעה בוואטסאפ"
      className="fixed bottom-6 left-6 z-50 flex items-center justify-center w-14 h-14 rounded-full shadow-lg transition-all duration-300 hover:scale-110 hover:shadow-xl"
      style={{ backgroundColor: "#25D366" }}
    >
      <MessageCircle className="text-white" size={28} fill="white" strokeWidth={0} />
    </a>
  );
};

export default WhatsAppButton;
